<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='7'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">安全设置</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_kbhei4"></div>
            <div class="cght_wdxxtoptwo3">安全设置</div>
            <ul class="cght_aqzxul">
              <li>
                <div class="cght_aqzxul1"><i class="iconfont"></i>强度：
                  <em class="cght_aqzxul1red" v-show="current_user.intensity =='弱'">弱</em>
                  <em class="cght_aqzxul1red" v-show="current_user.intensity =='中'">中</em>
                  <em class="cght_aqzxul1red" v-show="current_user.intensity =='强'">强</em>
                </div>
                <div class="cght_aqzxul2">登录密码</div>
                <div class="cght_aqzxul3">
                  <div class="cght_aqzxul3top">
                    <template v-if="current_user.intensity =='弱'">
                      <em class="cght_aqzxul3topxz">弱</em>
                      <em class="">中</em>
                      <em class="">强</em>
                    </template>
                    <template v-if="current_user.intensity =='中'">
                      <em class="cght_aqzxul3topxz">弱</em>
                      <em class="cght_aqzxul3topxz">中</em>
                      <em class="">强</em>
                    </template>
                    <template v-if="current_user.intensity =='强'">
                      <em class="cght_aqzxul3topxz">弱</em>
                      <em class="cght_aqzxul3topxz">中</em>
                      <em class="cght_aqzxul3topxz">强</em>
                    </template>
                  </div>
                  <div class="cght_aqzxul3bot">为了账户更加安全，建议您定期更换密码。</div>
                </div>
                <div class="cght_aqzxul4"><a href="javascript:;" class="cght_aqzxinxultop1a" @click="unfold('ZK')">修改</a></div>
              </li>
              <li>
                <template v-if="current_user.email">
                  <div class="cght_aqzxul1"><i class="iconfont cght_aqzxulls">&#xe60f;</i>已验证</div>
                  <div class="cght_aqzxul2">邮箱验证</div>
                  <div class="cght_aqzxul3">您验证的邮箱：{{current_user.email}}</div>
                  <div class="cght_aqzxul4"><a href="javascript:;" class="cght_aqzxinxultop3a" @click="unfold('YXZK')">修改</a></div>
                </template>
                <template v-else>
                  <div class="cght_aqzxul1"><i class="iconfont cght_aqzxulhs">&#xe613;</i>未验证</div>
                  <div class="cght_aqzxul2">邮箱验证</div>
                  <div class="cght_aqzxul3">邮箱验证方便您及时接受优惠促销信息，已经积分和优惠券变动的提醒。</div>
                  <div class="cght_aqzxul4" @click="unfold('YXZK')">
                    <div class="cght_aqzxulmycz"><a href="javascript:;" class="cght_aqzxinxultop3a">立即验证</a></div>
                  </div>
                </template>
              </li>
              <li>
                <div class="cght_aqzxul1"><i class="iconfont cght_aqzxulls">&#xe60f;</i>已验证</div>
                <div class="cght_aqzxul2">手机验证</div>
                <div class="cght_aqzxul3">您验证的手机：{{current_user.tel}}</div>
                <div class="cght_aqzxul4"><a href="javascript:;" class="cght_aqzxinxultop2a" @click="unfold('SJZK')">修改</a></div>
              </li>
            </ul>
            <ul class="cght_aqzxinxul">
              <li class="cght_aqzxinxultop1">
                <div class="cght_aqzxinx">
                  <div class="cght_aqzxinxleft">密&emsp;&emsp;码</div>
                  <div class="cght_aqzxinxan" @click="unfold('ZK')"><em v-if="!ZK">展开</em><span v-else>收起</span></div>
                </div>
                <div class="cght_aqzxinxtx" :style="ZK?'height: 225px;':'height:0;'">
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">当前密码：</span>
                    <em><el-input placeholder="请输入当前密码" v-model="old_password" show-password></el-input></em>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">新密码：</span>
                    <em><el-input placeholder="请输入新密码" v-model="new_password" show-password></el-input></em>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">确认新密码：</span>
                    <em><el-input placeholder="请确认新密码" v-model="new_twicpassword" show-password></el-input></em>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight"></span>
                    <a href="javascript:;" class="cght_aqzxinxtxda" style="display:inline-block" @click="savePassword">保存</a>
                  </div>
                </div>
              </li>
              <li class="cght_aqzxinxultop2">
                <div class="cght_aqzxinx">
                  <div class="cght_aqzxinxleft">手&emsp;&emsp;机</div>
                  <div class="cght_aqzxinxword">{{current_user.tel}}</div>
                  <div class="cght_aqzxinxan" @click="unfold('SJZK')"><em v-if="!SJZK">展开</em><span v-else>收起</span></div>
                </div>
                <div class="cght_aqzxinxtx" :style="SJZK?'height: 225px;box-sizing: border-box;':'height:0;overflow: hidden;'">
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">当前手机：</span>
                    <div class="cght_aqzxinxtxddhh">{{current_user.tel}}</div>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">校验码：</span>
                    <em class="cght_aqzxinxtxddem">
                      <el-input v-model="tel_code" placeholder="请输入校验码"></el-input>
                    </em>
                    <!-- <a href="javascript:;" class="cght_aqzxinxtxddhqyz">获取短信校验码</a> -->
                    <a href="javascript:;" class="cght_aqzxinxtxddhqyz" v-show="codeType" @click="sendCode">发送手机验证码</a>
                    <a href="javascript:;" class="cght_aqzxinxtxddhqyz" v-show="!codeType" >{{ count }}s</a>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">新手机号：</span>
                    <em class="cght_aqzxinxtxddem">
                      <el-input v-model="new_tel" placeholder="请输入新手机号码"></el-input>
                    </em>
                  </div>
                  <!--<div class="cght_aqzxinxtxd">
                    <span>验证码：</span>
                    <em class="cght_aqzxinxtxddem"><input type="text" /></em>
                    <div class="cght_aqzxinxtxdyzm"><img src="gf/images/yzm_02.jpg" width="129" height="32" alt=" " />看不清？<i>换一张</i></div>
                  </div>-->
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight"></span>
                    <a href="javascript:;" class="cght_aqzxinxtxda" style="display:inline-block" @click="replaceTel">保存</a>
                  </div>
                </div>
              </li>
              <li class="cght_aqzxinxultop3">
                <div class="cght_aqzxinx">
                  <div class="cght_aqzxinxleft">邮&emsp;&emsp;箱</div>
                  <div class="cght_aqzxinxword">{{current_user.email}}</div>
                  <div class="cght_aqzxinxan" @click="unfold('YXZK')"><em v-if="!YXZK">展开</em><span v-else>收起</span></div>
                </div>
                <div class="cght_aqzxinxtx" :style="YXZK?'height: 225px;box-sizing: border-box;':'height:0;overflow: hidden;'">
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">邮箱：</span>
                    <div class="cght_aqzxinxtxddhh">
                      <em>
                        <el-input v-model="new_email" placeholder="请输入邮箱号码"></el-input>
                      </em>
                    </div>
                  </div>
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight">校验码：</span>
                    <em class="cght_aqzxinxtxddem">
                      <el-input v-model="email_code" placeholder="请输入邮箱校验码"></el-input>
                    </em>
                    <a href="javascript:;" class="cght_aqzxinxtxddhqyz" v-show="emailType" @click="getEmailCode">获取邮箱校验码</a>
                    <a href="javascript:;" class="cght_aqzxinxtxddhqyz" v-show="!emailType" >{{ seconds }}s</a>
                  </div>
                  <!--<div class="cght_aqzxinxtxd">
                    <span>验证码：</span>
                    <em class="cght_aqzxinxtxddem"><input type="text" /></em>
                    <div class="cght_aqzxinxtxdyzm"><img src="gf/images/yzm_02.jpg" width="129" height="32" alt=""/>看不清？<i>换一张</i></div>
                  </div>-->
                  <div class="cght_aqzxinxtxd">
                    <span class="mynewweight"></span>
                    <a href="javascript:;" class="cght_aqzxinxtxda yxbc" style="display:inline-block" @click="saveEmail">保存</a>
                  </div>
                </div>
              </li>
            </ul>
            <!--右边内容区域完成-->
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import { sendSMS } from '@/api/login'
import { mapGetters } from 'vuex'
import api from '@/api/user'

export default {
  name: 'Safety',
  components: { Top, LeftNav, Bottom },
  data () {
    return {
      qyloading: false,
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        address_detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      ZK: false,
      SJZK: false,
      YXZK: false,
      old_password: '',
      new_password: '',
      new_twicpassword: '',
      timer: null,
      codeType: true,
      count: '',
      new_tel: '',
      tel_code: '',
      new_email: '',
      email_code: '',
      email_time: null,
      seconds: '',
      emailType: true
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
  },
  methods: {
    unfold (sha) {
      if (sha === 'ZK') {
        this.ZK = !this.ZK
      } else if (sha === 'SJZK') {
        this.SJZK = !this.SJZK
      } else if (sha === 'YXZK') {
        this.YXZK = !this.YXZK
      }
    },
    savePassword () {
      if (!this.old_password) {
        this.$message.error('请输入当前密码')
        return
      }
      if (!this.new_password) {
        this.$message.error('请输入新密码')
        return
      }
      if (!this.new_twicpassword) {
        this.$message.error('请确认新密码')
        return
      }
      if (this.new_twicpassword !== this.new_password) {
        this.$message.error('两次输入不相等')
        return
      }
      api.savePassword({old_password: this.old_password, new_password: this.new_password}).then(res => {
        this.$store.dispatch('user/logout', res)
        this.$message({
          message: '修改成功，重新登录',
          type: 'success'
        })
        this.$router.push({ path: '/' })
      })
    },
    sendCode () {
      sendSMS({tel: this.current_user.tel}).then(res => {
        console.info(res)
      })
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.codeType = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.codeType = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    replaceTel () {
      if (!this.tel_code) {
        this.$message.error('请输入校验码')
        return
      }
      const regs = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!this.new_tel || !regs.test(this.new_tel)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      api.saveTel({tel_code: this.tel_code, new_tel: this.new_tel}).then(res => {
        this.$store.dispatch('user/saveInformation', res).then(() => {
          this.new_tel = ''
          this.tel_code = ''
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        })
      })
    },
    getEmailCode () {
      var reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
      if (!this.new_email || reg.test(this.new_email)) {
        this.$message.error('请输入正确的邮箱')
        return
      }
      const TIME_COUNT = 60
      if (!this.email_time) {
        this.seconds = TIME_COUNT
        this.emailType = false
        this.email_time = setInterval(() => {
          if (this.seconds > 0 && this.seconds <= TIME_COUNT) {
            this.seconds--
          } else {
            this.emailType = true
            clearInterval(this.email_time)
            this.email_time = null
          }
        }, 1000)
      }
    },
    saveEmail () {
      var reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
      if (!this.new_email || reg.test(this.new_email)) {
        this.$message.error('请输入正确的邮箱')
        return
      }
      if (!this.email_code) {
        this.$message.error('请输入邮箱校验码')
        return
      }
      api.saveEmail({new_email: this.new_email, email_code: this.email_code}).then(res => {
        this.$store.dispatch('user/saveInformation', res).then(() => {
          this.new_email = ''
          this.email_code = ''
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        })
      })
    }
  }
}
</script>
<style scoped>
.cght_aqzxinxtx{
  transition: height 1s ease;
  overflow: hidden;
  box-sizing: border-box;
}
.mynewweight{
  width:195px;
}
.cght_aqzxinxtxd .cght_aqzxinxtxddem{
  width:150px;
}
</style>



// WEBPACK FOOTER //
// src/view/member/safety.vue